<section class="targeted-company-products-card" [class.targeted-company-products-card--embedded]="embedded()">
  <div class="targeted-company-products-card__header">
    <h2 class="targeted-company-products-card__title">{{ title() }}</h2>
    @if (description(); as description) {
      <p class="targeted-company-products-card__description">{{ description }}</p>
    }
  </div>

  <mat-radio-group class="targeted-company-products-card__list" [value]="scope()" (change)="onScopeChange($event.value)">
    @for (option of scope_options; track option) {
      <mat-radio-button class="targeted-company-products-card__item" [value]="option">
        {{ scope_labels[option] }}
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (is_manual()) {
    <mat-form-field appearance="outline" class="targeted-company-products-card__chips" [class.mat-form-field-invalid]="!!error_message()">
      <mat-label>Productos</mat-label>
      <mat-chip-grid #chipGrid aria-label="Productos seleccionados">
        @for (product of selection(); track product.id) {
          <mat-chip-row (removed)="removeProduct(product.id)">
            {{ displayProductLabel(product) }}
            <button matChipRemove type="button" [attr.aria-label]="'Quitar ' + displayProductLabel(product)">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          #search_input
          placeholder="Buscar..."
          [formControl]="search_control"
          [matChipInputFor]="chipGrid"
          [matAutocomplete]="productsAutocomplete"
          (blur)="onProductsInputBlur($event)"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #productsAutocomplete="matAutocomplete"
        [displayWith]="display_search_value"
        (optionSelected)="onProductSelected($event)"
        (closed)="onSearchPanelClosed()"
      >
        @for (product of suggestions(); track product.id) {
          <mat-option [value]="product">{{ displayProductLabel(product) }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    @if (error_message(); as message) {
      <p class="targeted-company-products-card__error" role="alert">{{ message }}</p>
    }
  }
</section>
